import type { User } from "firebase/auth";
import { authStore, setAuthStore } from "./store";

export function setProfile(profile: Partial<User> | null) {
	if (!profile) {
		setAuthStore("profile", null);
		return;
	}

	setAuthStore("profile", {
		email: profile.email,
		displayName: profile.displayName,
	});
}

export function setAuthToken(token: string | undefined) {
	setAuthStore("token", token ?? null);
}

export function invalidateProfile() {
	setAuthStore("profile", null);
}

export const isAuthenticated = () => !!authStore.profile && !!authStore.token;
